import * as DialogPrimitive from '@radix-ui/react-dialog'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { RichText } from '@sunwebgroup/uds-ui/rich-text'
import { Sheet } from '@sunwebgroup/uds-ui/sheet'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import * as React from 'react'
import { useIntl } from '@/intl'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { usePaymentContext } from '@/scopes/payment/domain/PaymentContext'
import { getFaqInfo } from '@/scopes/payment/domain/policies/publicationCode'
import { PaymentResult, PaymentResultValues, PaymentScopePageValues } from '@/scopes/payment/domain/types'
import styles from './PaymentFaq.module.css'

export function PaymentFaq({ paymentResult }: { paymentResult: PaymentResult | null }) {
  const intl = useIntl()
  const publicationCode = useConfiguration('publicationCode')
  const infoAndFAQsItems = getFaqInfo(publicationCode)
  const { scope } = usePaymentContext()

  if (scope === PaymentScopePageValues.BOOKING_PAYMENT) {
    return null
  }

  if (!infoAndFAQsItems?.length) {
    return null
  }

  if (!paymentResult || paymentResult === PaymentResultValues.OK || paymentResult === PaymentResultValues.PENDING) {
    return null
  }

  return (
    <div className={styles.faqContainer}>
      <div className={styles.faqTitleWrapper}>
        <Typography className={styles.faqTitle} variant="body-l-bold-tight">
          {intl.formatMessage({ id: 'payment_scope_faq_title' })}
        </Typography>
      </div>
      <div className={styles.faqList}>
        {infoAndFAQsItems?.map(item => (
          <Sheet.Root key={item.title}>
            <Sheet.Trigger>
              <button type="button" className={styles.faqItem}>
                <Typography variant="body-l-regular-loose">{item.title}</Typography>
                <Icon glyph="ChevronRight" size={20} />
              </button>
            </Sheet.Trigger>
            <Sheet.Body side="right">
              <DialogPrimitive.Title className={styles.dialogTitle}>{item.title}</DialogPrimitive.Title>
              <Sheet.Header closeLabel={intl.formatMessage({ id: 'close' })} className={styles.faqHeader} />
              <Sheet.Content className={styles.faqContentWrapper}>
                <Typography variant="body-m-bold-snug">{item.title}</Typography>
                <RichText innerHTML={item.text} />
              </Sheet.Content>
            </Sheet.Body>
          </Sheet.Root>
        ))}
      </div>
    </div>
  )
}
